

//files type : license, payslips, bank statements, etc
//ASK THE USER TO PUT THE FILE TYPE AND THEN UPLOAD THE FILE

import React, { useEffect, useState } from 'react';
import UploadFile from './UploadFile';
import 'primereact/resources/themes/lara-light-cyan/theme.css';

const Files = (props) => {
    const [tokenInfo, setTokenInfo] = useState({ applicationId: "", applicantId: 0, token: "" });
    const [uploadedFileCount, setUploadedFileCount] = useState(0);
    const [isCompleted, setIsCompleted] = useState(false);
    const [message, setMessage] = useState("");

    const handleFinishUpload = () => {
        setIsCompleted(true);
        setMessage("✅ Thank you for uploading your documents! A broker will contact you within 24 hours.");
    };

    const handleSkipUpload = () => {
        setIsCompleted(true);
        setMessage("⏳ You can upload your documents later. A broker will reach out to assist you.");
    };


    //READ TOKEN 
    const params = new URLSearchParams(window.location.search);
    const base64Token = params.get('token');
    console.log("base64Token:: ", base64Token);

    useEffect(() => {
        const decodeToken = () => {
            try {
                if (base64Token !== null && base64Token !== undefined && base64Token !== "" && base64Token) {
                    let decodedBase64Token = JSON.parse(atob(base64Token));

                    //SET TOKEN INFO
                    setTokenInfo({
                        applicationId: decodedBase64Token.applicationId,
                        applicantId: decodedBase64Token.applicantId,
                        token: decodedBase64Token.token
                    });
                }
            }
            catch (e) { }
        }
        decodeToken();
    }, []);

   return (
        <div className="container-xxl">
            <div className="card card-flush mt-8">
                <div className="card-header">
                    <div className="row align-items-center">
                        <div className="card-title">
                            <h2 className="mb-0 mt-2">Upload Files</h2>
                        </div>
                        <div>
                            <p className="text-sm">
                                Please upload all necessary documents, including your driver's license, your two most recent payslips, and your Medicare card.
                            </p>
                        </div>
                    </div>
                </div>

                {/*********** FILE UPLOAD BODY ***********/}
                <div className="card-body">
                
                {!isCompleted ? (<div className="row">
                        <div className="col-sm-12">
                            <UploadFile
                                applicationId={tokenInfo.applicationId}
                                applicantId={tokenInfo.applicantId}
                                token={tokenInfo.token}
                                onUpload={setUploadedFileCount} // Track uploaded file count
                            />
                        </div>
                    </div>
                ) : "" }

                     
                    {/*********** BUTTONS ***********/}
                    {!isCompleted ? (
                        <div className="mt-4 text-center">
                            {uploadedFileCount > 0 && (
                                <button className="btn btn-primary me-3" onClick={handleFinishUpload}>
                                    I have uploaded all necessary files
                                </button>
                            )}
                            <button className="btn btn-secondary" onClick={handleSkipUpload}>
                                I will provide files later
                            </button>
                        </div>
                    ) : (
                        <div className="mt-4 alert alert-success text-center">{message}</div>
                    )}
                </div>
            </div>
        </div>
    );

}

export default Files;